import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <p id='copyright'>&copy; Hazel Windle</p>
      <p id='github'><a id='footer-github-link' href='https://github.com/hwindle/reactive-words'>Link to source code</a></p>
    </footer>
  );
};

export default Footer;